module.exports = __webpack_public_path__ + "static/media/farmindia_img_5.d9ef5487.png";